/**
 * Created by or_p on 6/18/2016.
 */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import * as Colors from 'material-ui/styles/colors';
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';
import SvgIcon from 'material-ui/SvgIcon';
import FontIcon from 'material-ui/FontIcon';
import IconButton from 'material-ui/IconButton';
import {HoverMixin} from 'shared/helpers/mixins';
import _ from 'lodash';
import { DragSource, DropTarget } from 'react-dnd';
import {findDOMNode} from 'react-dom';

const ItemTypes = {
  TAB: 'tabTitle'
};

const styles = {
  container: {
    display: 'flex',
    margin: 8,
    height: 80,
    width: '100%',
  },
  paper: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
  },
  textField: {
    flexGrow: 1,
    position: 'relative',
    top: -10
  },
  dragIcon: {
    width: 40,
    height: 40,
  },
};

const tabSource = {
  beginDrag(props) {
    return {
      id: props.id,
      index: props.index
    };
  },
  isDragging(props, monitor) {
    const returnValue = props.id === monitor.getItem().id;
    return returnValue;
  }
};

const tabTarget = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Determine rectangle on screen
    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

    // Get vertical middle
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

    // Determine mouse position
    const clientOffset = monitor.getClientOffset();

    // Get pixels to the top
    const hoverClientY = clientOffset.y - hoverBoundingRect.top;

    // Only perform the move when the mouse has crossed half of the items height
    // When dragging downwards, only move when the cursor is below 50%
    // When dragging upwards, only move when the cursor is above 50%

    // Dragging downwards

    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return;
    }

    // Dragging upwards
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return;
    }

    // Time to actually perform the action
    props.moveTab(dragIndex, hoverIndex);

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex;
    monitor.getItem().id = props.id;
  }
};

@DropTarget(ItemTypes.TAB, tabTarget, connect => ({
  connectDropTarget: connect.dropTarget()
}))
@DragSource(ItemTypes.TAB, tabSource, (connect, monitor) => {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  };
})
export default class Tab extends Component {
  state = {};

  componentDidMount() {
    const {title} = this.props;
    if (_.isEmpty(title)) {
      this.refs.textField.focus();
    }
  }

  getValue() {
    return this.refs.textField.getValue();
  }

  render() {
    const {title, onDelete, connectDragSource, connectDropTarget, onChange, connectDragPreview} = this.props;
    const {hovered} = this.state;
    return connectDropTarget(connectDragPreview(
      <span
        onMouseEnter={HoverMixin.onMouseEnter.bind(this)}
        onMouseLeave={HoverMixin.onMouseLeave.bind(this)}
        style={styles.container}
      >
        <Paper
          style={styles.paper}
        >
          {connectDragSource(<span style={{cursor: 'move'}}><DragIcon style={{opacity: hovered ? 1 : 0}} color={Colors.grey400}/></span>)}
          <TextField
            style={styles.textField}
            floatingLabelText="Tab Title"
            hintText="Insert Tab Title"
            defaultValue={title}
            ref="textField"
            onBlur={(event) => {onChange(event.target.value);}}
          />
          <IconButton
            iconStyle={{color: Colors.grey800}}
            style={{opacity: hovered ? 1 : 0}}
            onClick={onDelete}
          >
            <FontIcon className="material-icons">delete</FontIcon>
          </IconButton>
        </Paper>
      </span>));
  }
}

Tab.propTypes = {
  moveTab: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

class DragIcon extends Component {
  render() {
    return (<SvgIcon style={{...styles.dragIcon, ...this.props.style}}>
      <path fill={this.props.color || this.props.style.color}
            d="M9,3H11V5H9V3M13,3H15V5H13V3M9,7H11V9H9V7M13,7H15V9H13V7M9,11H11V13H9V11M13,11H15V13H13V11M9,15H11V17H9V15M13,15H15V17H13V15M9,19H11V21H9V19M13,19H15V21H13V19Z"/>
    </SvgIcon>);
  }
}